import { Component } from '@angular/core';
import { GlobalLoaderService } from './global-loader.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-global-loader',
  templateUrl: './global-loader.component.html',
  styleUrls: ['./global-loader.component.scss']
})
export class GlobalLoaderComponent {
  isLoading: Subject<boolean> = this.loaderService.isLoading;

  constructor(private loaderService: GlobalLoaderService) {}

}
